import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { Employeur } from "../../core/model/employeur";
import { EmployeurService } from "../../core/service/employeur.service";
import { ClassificationEmployeurService } from '../../core/service/classification-employeur.service';
import { ClassificationEmployeur } from '../../core/model/classification-employeur';

@Component({
  selector: "app-add-employeur",
  templateUrl: "./add-employeur.component.html",
  styleUrls: ["./add-employeur.component.scss"],
})
export class AddEmployeurComponent implements OnInit {
  employeur: Employeur = new Employeur();
  classificationEmployeurs : ClassificationEmployeur[]

  form2: FormGroup;
  pressButton: Boolean = false;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _employeurService: EmployeurService,
    private _classificationEmployeurService : ClassificationEmployeurService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      label: [null, Validators.compose([Validators.required])],
      description: [null, Validators.compose([Validators.nullValidator])],
      echeance: [null, Validators.compose([Validators.required])],
      classificationEmployeur: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getClassifications();
  }

  getClassifications() {
    this._classificationEmployeurService.getAll().subscribe(
      (data) => {
        this.classificationEmployeurs = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save(): void {
    this.pressButton = true;
    this.employeur.active = true;
    this._employeurService
      .add(this.employeur)
      .pipe(first())
      .subscribe(
        (data) => {
          this.pressButton = false;
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
